import { trigger } from '../core/event.js';
import { select } from '../core/query.js';
export default {
    name: 'header',
    defaultOpt: {
        shown: false,
        showbefore: null,
        showafter: null,
        hidebefore: null,
        hideafter: null,
        target: null,
    },
    init: function ($el, opt, exportObj) {
        exportObj.show = function () {
            opt.showbefore && trigger(opt.showbefore, $el, opt, exportObj);
            var $body = select('#body');
            $body.classList.add('expand');
            exportObj.shown = true;
            opt.showafter && trigger(opt.showafter, $el, opt, exportObj);
        };
        exportObj.hide = function () {
            opt.hidebefore && trigger(opt.hidebefore, $el, opt, exportObj);
            var $body = select('#body');
            $body.classList.remove('expand');
            exportObj.shown = false;
            opt.hideafter && trigger(opt.hideafter, $el, opt, exportObj);
        };

        exportObj.toggle = function () {
            var $body = select('#body');
            if ($body.classList.contains('expand')) {
                exportObj.hide();
            } else {
                exportObj.show();
            }
        };
    },
    setOptionsBefore: null,
    setOptionsAfter: null,
    initBefore: null,
    initAfter: function ($el, opt, exportObj) {
        var overlay = document.querySelector('.header-overlay');
        if (!overlay) {
            return;
        }
        overlay.addEventListener('click', exportObj.hide);
        var switchLink = document.querySelector('.header-switch-link');
        switchLink.addEventListener('click', exportObj.show);
        var arrows = document.querySelectorAll('.header-expand');
        arrows.forEach(function (arrow) {
            arrow.addEventListener('click', function () {
                var list = document.querySelectorAll('.header-menu-list .list');
                var curr = arrow.parentNode;
                list.forEach(function (i) {
                    if (i !== curr) {
                        if (i.classList.contains('hover')) {
                            i.classList.remove('hover');
                            i.style.removeProperty('height');
                        }
                    } else {
                        i.classList.toggle('hover');
                        if (i.classList.contains('hover')) {
                            i.style.height = i.scrollHeight + 'px';
                        } else {
                            i.style.removeProperty('height');
                        }
                    }
                });
            });
        });
        if (opt.shown) {
            exportObj.show();
        } else {
            exportObj.hide();
        }
    },
    destroyBefore: function ($el) {},
};
